import React, { useEffect, useState } from "react";
import RCPagination from "rc-pagination";
import { useTranslation } from "react-i18next";
import {get} from "lodash";
import { countryLists } from "../config";
import ListItems from "./ListItems";
import Tabs from "./Tabs";
import appConfig from "../../config";

var requestOptions = {
  method: "GET",
  redirect: "follow"
};

const PAGE_SIZE = 20;

const SellersList = () => {
  const [activeTab, setActiveTab] = useState(countryLists[0].code);
  const [isLoading, setIsLoading] = useState(true);
  const [results, setResults] = useState([]);
  const [sellers, setSellers] = useState([]);
  const [visibleSellers, setVisibleSellers] = useState([]);
  const { t } = useTranslation();

  const changeVisibleSellers = (
    sellers,
    currentPage = 1,
    pageSize = PAGE_SIZE
  ) => {
    const firstIndex = (currentPage - 1) * pageSize;
    const lastIndex = pageSize * currentPage;
    setVisibleSellers(sellers.slice(firstIndex, lastIndex));
  };

  useEffect(() => {
    setIsLoading(true);
    const url = `${appConfig.octopartAPIUrl}?model=${window.omModelNumber}&country=${activeTab}`;
    function setData(response) {
      const results = get(response, 'data.search.results', []);

      setResults(results);
      const sellers = results.reduce((sellers, result) => {
        const part = result.part;
        const octopartUrl = part.octopartUrl;
        const mpn = part.mpn;
        const manufacturer = part.manufacturer;
        return [
          ...sellers,
          ...part.sellers.map(seller => ({
            ...seller,
            octopartUrl,
            mpn,
            manufacturer
          }))
        ];
      }, []);
      setSellers(sellers);
      changeVisibleSellers(sellers);

      setIsLoading(false);
    }
    fetch(url, requestOptions)
      .then(response => response.json())
      .then(setData)
      .catch(e => {
        setIsLoading(false);
        setVisibleSellers([]);
      });
  }, [activeTab]);

  const textItemRender = (current, type, element) => {
    if (type === "prev") {
      return t("prev");
    }
    if (type === "next") {
      return t("next");
    }
    if (type === "jump-prev") {
      return;
    }
    if (type === "jump-next") {
      return;
    }
    return element;
  };
  return (
    <div style={{minHeight: '550px'}}>
      <Tabs {...{ setActiveTab, activeTab }} />
      {
        visibleSellers.length > 0 && !isLoading ? <>
          <ListItems results={results} sellers={visibleSellers} />
          <RCPagination
            hideOnSinglePage
            total={sellers.length}
            pageSize={PAGE_SIZE}
            className="c-pager sui-paging"
            itemRender={textItemRender}
            onChange={(currentPage, pageSize) => {
              changeVisibleSellers(sellers, currentPage, pageSize);
            }}
          />
        </> : <div style={{margin: '5rem 0'}}>{ isLoading ? t("Loading ...") : t('There is no distributor inventory.')}</div>
      }

    </div>
  );
};

export default SellersList;
